function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
(function() {
    "use strict";
    var elementorHelloThemeHandler = /*#__PURE__*/ function() {
        function elementorHelloThemeHandler() {
            _class_call_check(this, elementorHelloThemeHandler);
            this.initSettings();
            this.initElements();
            this.markActiveMenuItems();
            this.bindEvents();
        }
        _create_class(elementorHelloThemeHandler, [
            {
                key: "initSettings",
                value: function initSettings() {
                    this.settings = {
                        selectors: {
                            body: "body",
                            header: "header.site-header",
                            footer: "footer.site-footer",
                            menuToggle: ".site-header .site-navigation-toggle",
                            menuToggleHolder: ".site-header .site-navigation-toggle-holder",
                            dropdownMenu: ".site-navigation-dropdown",
                            openNavHeader: ".site-header .open-nav-header",
                            menuItems: ".site-navigation-dropdown .menu-item"
                        }
                    };
                }
            },
            {
                key: "initElements",
                value: function initElements() {
                    this.elements = {
                        $window: jQuery(window),
                        $document: jQuery(document),
                        $body: jQuery(this.settings.selectors.body),
                        $header: jQuery(this.settings.selectors.header),
                        $footer: jQuery(this.settings.selectors.footer),
                        $menuToggle: jQuery(this.settings.selectors.menuToggle),
                        $openNavToggle: jQuery(this.settings.selectors.openNavToggle),
                        $menuToggleHolder: jQuery(this.settings.selectors.menuToggleHolder),
                        $dropdownMenu: jQuery(this.settings.selectors.dropdownMenu),
                        $openNavHeader: jQuery(this.settings.selectors.openNavHeader),
                        $menuItems: jQuery(this.settings.selectors.menuItems)
                    };
                }
            },
            {
                // Match current URL with menu item links and mark them
                key: "markActiveMenuItems",
                value: function markActiveMenuItems() {
                    var currentPath = window.location.pathname.replace(/\/$/, "");
                    this.elements.$menuItems.each(function(_, el) {
                        var $link = jQuery(el).find("a").first();
                        if (!$link.length) return;
                        var linkPath = new URL($link[0].href).pathname.replace(/\/$/, "");
                        if (linkPath === currentPath && linkPath !== "") {
                            jQuery(el).attr("data-persistent-active", "true");
                            $link.addClass("active");
                        }
                    });
                }
            },
            {
                key: "bindEvents",
                value: function bindEvents() {
                    var _this = this;
                    // Toggle open/close on click or keyup
                    this.elements.$menuToggle.on("click", function() {
                        return _this.handleMenuToggle();
                    }).on("keyup", function(e) {
                        if (e.key === "Escape" || e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            e.currentTarget.click();
                        }
                    });
                    // Handle menu item with children
                    this.elements.$dropdownMenu.on("click", ".menu-item-has-children > a", this.handleMenuChildren);
                    // Handle tabbing out of the last menu link
                    var lastLinkEl = this.elements.$menuItems.last().find("a")[0];
                    if (lastLinkEl) {
                        lastLinkEl.addEventListener("keydown", function(e) {
                            var isTab = e.key === "Tab" || e.keyCode === 9;
                            var isForward = !e.shiftKey;
                            if (isTab && isForward && document.body.classList.contains("open-site-nav")) {
                                // Close dropdown
                                _this.handleMenuToggle();
                            // Move focus to next tabbable element in DOM
                            // setTimeout(() => {
                            //   const focusable = document.querySelector(
                            //     '#site-navigation-toggle'
                            //   );
                            //   if (focusable) {
                            //     window.scrollTo(0, 0);
                            //     focusable.focus();
                            //   }
                            // }, 0);
                            }
                        });
                    }
                    this.elements.$document.on("click", function(e) {
                        var $target = jQuery(e.target);
                        var isClickInsideDropdown = $target.closest(_this.settings.selectors.dropdownMenu).length > 0;
                        var isClickOnToggle = $target.closest(_this.settings.selectors.menuToggle).length > 0;
                        var isMenuOpen = _this.elements.$menuToggleHolder.hasClass("elementor-active");
                        if (!isClickInsideDropdown && !isClickOnToggle && isMenuOpen) {
                            _this.handleMenuToggle(); // This will close the menu
                        }
                    });
                }
            },
            {
                key: "closeMenuItems",
                value: function closeMenuItems() {
                    this.elements.$menuToggleHolder.removeClass("elementor-active");
                }
            },
            {
                key: "handleMenuToggle",
                value: function handleMenuToggle() {
                    window.scrollTo(0, 0);
                    var isOpening = !this.elements.$menuToggleHolder.hasClass("elementor-active");
                    this.elements.$menuToggle.attr("aria-expanded", isOpening);
                    this.elements.$dropdownMenu.attr("aria-hidden", !isOpening);
                    this.elements.$menuToggleHolder.toggleClass("elementor-active", isOpening);
                    this.elements.$dropdownMenu.find(".elementor-active").removeClass("elementor-active");
                    if (isOpening) {
                        jQuery.each(this.elements.$menuItems, function(k, v) {
                            v.querySelector("a").tabIndex = 0;
                            v.querySelector("a").tabIndex = 0;
                            v.classList.remove("transition-delay-none");
                            v.querySelector("a").setAttribute("aria-hidden", "false");
                        });
                        this.elements.$openNavHeader.toggleClass("active", true);
                        this.elements.$dropdownMenu.css("transition-delay", "0s");
                        this.elements.$body.addClass("open-site-nav nav-animating");
                        this.elements.$menuToggleHolder.find(".second-line").attr("d", "M2 1.67578L34 1.67578");
                        this.elements.$menuToggleHolder.find(".first-line").addClass("rotate-1").attr("stroke-width", "2.5");
                        this.elements.$menuToggleHolder.find(".second-line").addClass("rotate-2");
                        jQuery(".nav-modal-logo-link").focus();
                    } else {
                        setTimeout(function() {
                            jQuery(".open-nav-header").toggleClass("active", false);
                            jQuery(".first-line").removeClass("rotate-1");
                            jQuery(".second-line").removeClass("rotate-2");
                            jQuery(".site-navigation-toggle-holder").find(".second-line").attr("d", "M11.0439 9.32812L34.0005 9.32812");
                        }, 1);
                        setTimeout(function() {
                            jQuery("body").removeClass("open-site-nav");
                        // jQuery('#navigation-toggle').focus();
                        }, 0);
                        setTimeout(function() {
                            jQuery("body").removeClass("nav-animating");
                        }, 900);
                        jQuery.each(this.elements.$menuItems, function(k, v) {
                            var $el = jQuery(v);
                            var $link = $el.find("a").first();
                            v.querySelector("a").tabIndex = -1;
                            v.querySelector("a").setAttribute("aria-hidden", "true");
                            v.classList.add("transition-delay-none");
                            if (!$el.attr("data-persistent-active")) {
                                $link.removeClass("active");
                            }
                        });
                        this.elements.$dropdownMenu.css("transition-delay", "0.3s");
                    }
                }
            },
            {
                key: "handleMenuChildren",
                value: function handleMenuChildren(e) {
                    var t = jQuery(e.currentTarget).parent("li");
                    t.toggleClass("elementor-active");
                }
            }
        ]);
        return elementorHelloThemeHandler;
    }();
    jQuery(function() {
        new elementorHelloThemeHandler();
    });
})();
